// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2zHGq","label":"Completed_label__33Azu"};